<template>
  <div id="dashboard-analytics">

    <!-- CARD 1: PUBLISHED NEWS -->
    <vs-row>
      <vs-col class="mb-3" vs-w="12">
        <vs-card>
          <div slot="header">
            <h3>
              Notícias Publicadas - Últimos 12 Meses
            </h3>
          </div>

          <e-charts 
            autoresize 
            :options="publishedNews" 
            theme="default-theme" 
            ref="bar" 
            auto-resize
          />
        </vs-card>
      </vs-col>
    </vs-row>

    <!-- CARD 2: NEWSLETTER SUBSCRIBERS -->
    <vs-row>
      <vs-col class="mb-3" vs-w="12">
        <vs-card>
          <div slot="header">
            <h3>
              Assinantes da Newsletter - Últimos 12 Meses
            </h3>
          </div>

          <e-charts 
            autoresize 
            :options="newsletterSubscriptions" 
            theme="default-theme" 
            ref="bar" 
            auto-resize
          />
        </vs-card>
      </vs-col>
    </vs-row>

  </div>
</template>

<script>
import dashboardStatistics from '@/http/requests/dashboardStatistics'

import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import eChartTheme from './eChartTheme.json'

ECharts.registerTheme('default-theme', eChartTheme)

export default {
  data() {
    return {
      publishedNews: {},
      newsletterSubscriptions: {},
    }
  },
  components: {
    ECharts
  },
  created() {
    dashboardStatistics
      .publishedNews()
      .then(res => {
        const { publishedNews } = res.data.data
        const dateList = publishedNews.map(item => item.month_year)
        const valueList = publishedNews.map(item => item.quantity)
        this.publishedNews = {
          // Make gradient line here
          visualMap: [{
            show: false,
            type: 'continuous',
            seriesIndex: 0,
            min: 0,
            max: 400
          }],
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            data: dateList
          },
          yAxis: {
            splitLine: {show: false},
          },
          series: {
            type: 'bar',
            showSymbol: true,
            data: valueList
          }
        }
      })
      .catch(err => { console.error(err) })

    dashboardStatistics
      .newsletterSubscriptions()
      .then(res => {
        const { newsletterSubscriptions } = res.data.data
        const dateList = newsletterSubscriptions.map(item => item.month_year)
        const valueList = newsletterSubscriptions.map(item => item.quantity)
        this.newsletterSubscriptions = {
          // Make gradient line here
          visualMap: [{
            show: false,
            type: 'continuous',
            seriesIndex: 0,
            min: 0,
            max: 400
          }],
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            data: dateList
          },
          yAxis: {
            splitLine: {show: false},
          },
          series: {
            type: 'bar',
            showSymbol: true,
            data: valueList
          }
        }
      })
      .catch(err => { console.error(err) })
  }
}
</script>
